import { ResponsiveContext } from '@/components/Responsive/ResponsiveProvider';
import { EPlatform } from '@/utils/enums/platform-enum';
import { CircularProgress } from '@mui/material';
import { useContext } from 'react';

interface LoadingCircularProps {
  loadingText?: string;
  wrapperClassName?: string;
  size?: number;
}
const LoadingCircular = ({
  loadingText = 'Loading...',
  wrapperClassName = '',
  size,
}: LoadingCircularProps) => {
  const { deviceType } = useContext(ResponsiveContext);
  return (
    <div
      className={`w-full text-center text-12 text-auxiliary-dark-gray h-[64px] leading-[64px] flex items-center justify-center ${
        deviceType === EPlatform.WEB ? 'text-14' : 'text-12'
      } ${wrapperClassName}`}
    >
      <CircularProgress
        size={size || (deviceType === EPlatform.WEB ? 22 : 14)}
        className="mr-8"
        color="inherit"
      />
      {loadingText}
    </div>
  );
};

export default LoadingCircular;
